import { Component, OnInit } from '@angular/core';
import { Company } from 'app/models';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { take } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-recent-company',
  templateUrl: './recent-company.component.html',
  styleUrls: ['./recent-company.component.scss']
})
export class RecentCompanyComponent implements OnInit {
  recentCompanies: Company[];
  isInternal = false;
  constructor(
    private readonly _router: Router, 
    private readonly authService: AuthService) {
    if (localStorage.getItem('recentCompanies')) {
      const recentCompanies = JSON.parse(localStorage.getItem('recentCompanies'));
      if(recentCompanies.some(company => !company.companyId)){
        localStorage.removeItem('recentCompanies');
      }
      else{
        this.recentCompanies = recentCompanies;
      }
    }
  }
 
  ngOnInit() {
    this.authService.user$.pipe(take(1)).subscribe(res => {
      this.isInternal = res?.isInternal ?? false;
    })
  }

  navigateToUserPage(company) {
    this._router.navigate(['company', company.companyId]);
  }
}
